import DrawerHandle from "./DrawerHandle";
import Lib from "../Lib";

export default class Drawer {
    /**
     * @param {HTMLElement} container
     * @constructor
     */
    constructor(container) {
        this._container = container;
        this._isOpen = container.classList.contains('open');

        this._detectHandles(container);
    }

    /**
     * Toggles the drawer
     */
    toggle() {
        if (this._isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    /**
     * Shows the drawer content
     */
    open() {
        this._container.classList.add('open');
        this._isOpen = true;
    }

    /**
     * Hides the drawer content
     */
    close() {
        this._container.classList.remove('open');
        this._isOpen = false;
    }

    /**
     * Returns if the handle does NOT point to a real location
     *
     * @param {HTMLElement|HTMLLinkElement} handle
     * @return {boolean} Returns FALSE if the element points to a anchor or another page
     * @private
     */
    _isNotALink(handle) {
        const link = handle.tagName === 'A' ? handle : (handle.parentNode.tagName === 'A' ? handle.parentNode : null);
        if (null === link) {
            return true;
        }

        return !(link.href && link.href.slice(-1) !== '#');
    }

    /**
     * @param {HTMLElement} container
     * @return {DrawerHandle[]}
     * @private
     */
    _detectHandles(container) {
        const onlyUnique = function (value, index, self) {
            return self.indexOf(value) === index;
        };

        const unique = []
            .concat(
                this._detectMainHandles(container),
                this._detectRemoteHandles(container)
            )
            .filter(onlyUnique);

        const drawerInstance = this;


        return Lib.map(unique, function (handle) {
            return new DrawerHandle(handle, drawerInstance);
        });
    }

    /**
     * @param {HTMLElement} container
     * @return {DrawerHandle[]}
     * @private
     */
    _detectMainHandles(container) {
        // Filter out handles that point to a real location (e.g. a anchor, another page)
        return Lib.filter(container.querySelectorAll('.drawer-handle'), this._isNotALink);
    }

    /**
     * @param {HTMLElement} container
     * @return {DrawerHandle[]}
     * @private
     */
    _detectRemoteHandles(container) {
        const selector = '[data-drawer-handle="' + this._getContainerIdentifier(container) + '"]';

        return Array.prototype.slice.call(document.querySelectorAll(selector), 0);
    }

    /**
     * @param {HTMLElement} container
     * @return {string}
     * @private
     */
    _getContainerIdentifier(container) {
        const dataDrawer = container.getAttribute('data-drawer');

        return dataDrawer ? dataDrawer : container.id ? container.id : '';
    }
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/Ui/Drawer.js